import { render, staticRenderFns } from "./site-card.vue?vue&type=template&id=0feca530&scoped=true&"
import script from "./site-card.vue?vue&type=script&lang=js&"
export * from "./site-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feca530",
  null
  
)

export default component.exports